var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UserRegistrationLayout',{staticClass:"delete-account-container"},[(!_vm.isLoading)?_c('div',{staticClass:"delete-account"},[(!_vm.errorMsg)?_c('div',[_vm._v("Sad to see you go... your workspace is being deleted")]):_c('div',[_c('div',[_vm._v("Something went wrong.")]),_c('div',[_vm._v(_vm._s(_vm.errorMsg))])])]):_c('AppLoader')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }